// import React from "react";
// import "../css/navbar.css"
// // import axios from "axios"
// import axios from "./components/customAxios.js"
// import baseUrl from "../base_url.js"
// import jutexx from "../media/jutexxbg.png"
// import { Link } from "react-router-dom";

// function Navbar(){
//     // const [cart, setCart] = React.useState(JSON.parse(localStorage.getItem("cart")) || []);
//     // const len = cart.length

//     const [loggedIn , setLoggedIn] = React.useState(false)
//     const [cartLen , setCartLen] = React.useState(0);



//     React.useEffect(() => {
//         const checkLoginStatus = async () => {
//             try {
//                 const accessToken = localStorage.getItem("accessToken");

//                 const config = {
//                     withCredentials: true,
//                     headers: {}
//                 };

//                 // iPhone fallback
//                 if (accessToken) {
//                     config.headers.Authorization = `Bearer ${accessToken}`;
//                 }

//                 let response = await axios.get(`${baseUrl}api/auth/IsLoggedIn`, config);
//                 console.log(response)
//                 setLoggedIn(true);

//                 response = await axios.get(`${baseUrl}api/cart/get-cart`, config);
//                 setCartLen(response?.data?.data?.cart?.length || 0);
//             } catch (err) {
//                 console.error("Error while checking login status:", err.response?.data || err.message);
//                 localStorage.removeItem("accessToken")
//             }
//         };

//         checkLoginStatus();
//     }, []);


//     const cartText = React.useMemo(() => {
//         return loggedIn ? `Cart (${cartLen})` : "Cart (0)";
//     }, [loggedIn, cartLen]);



//     return(
//         <div className="navbar">

//             <div className="nav_top">
//                 <div className="nav_top_left pl-[5%] flex items-center !gap-[40px]  ">
//                     {/* <a href="https://wa.me/+918398862901">Contact Us On <i className="fa-brands fa-whatsapp"></i> </a> */}
//                     {/* <a href="/newsletter">Follow Us On <i className="fa-brands fa-instagram"></i></a> */}
//                     <a href="/find_stores">Find a store</a>
//                     {/* <a className="text-2xl" href="https://wa.me/+918398862901">
//                         <i className="fa-brands fa-whatsapp"></i>
//                     </a> */}
//                 </div>
//                 <div className="nav_top_middle">
//                     <a href="/"><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRq1n8MdAYvQMMDlpTRkvdYosPoxKbmX-4gUw&s" alt="H&M"></img></a> 
//                     {/* <a className=" flex items-center content-center" href="/"><img className="scale-[3]"  src={jutexx} alt="H&M"></img></a>  */}
//                     {/* <Link to="/" className="flex items-center">
//                     <h1 className="text-4xl font-display font-semibold text-jute-800">Jutexx</h1>
//                     </Link> */}
//                 </div>
//                 <div className="nav_top_right ">
//                     { !loggedIn && 
//                         <a href="/login">
//                             <i class="fa-light fa-user"></i>
//                             <p>Sign in</p>
//                         </a>
//                     }
//                     { loggedIn && 
//                         <a href="/profile">
//                             <i class="fa-light fa-user"></i>
//                             <p>Profile</p>
//                         </a>
//                     }
//                     <a href="/favourites">
//                         <i class="fa-light fa-heart"></i>
//                         <p>Favourites</p>
//                     </a>
//                     <a href="/cart">
//                         <i class="fa-light fa-bag-shopping"></i>
//                          <p>{cartText}</p>
                        
//                     </a>
//                 </div>
//             </div>
//             <div className="nav_bottom">

//                 <a href="/store/ladies">Ladies</a>
//                 <a href="/store/men">Men</a>
//                 <a href="/store/baby">Baby</a>
//                 <a href="/store/kids">Kids</a>
//                 <a href="/store/home">H&M HOME</a>
//                 <a href="/store/sport">Sport</a>
//                 <a href="/sale">Sale</a>
//                 <a href="/sustainability">Sustainability</a>
//                 {/* <a href="/store/products">
//                     <p className="text-[16px] font-display font-semibold text-jute-800">View Products</p>
//                 </a> */}

//             </div>

//         </div>
//     )
// }

// export default Navbar

import React from "react";
import "../css/navbar.css"
// import axios from "axios"
import axios from "./components/customAxios.js"
import baseUrl from "../base_url.js"
import jutexx from "../media/jutexxbg.png"
import { Link } from "react-router-dom";

function Navbar(){
    // const [cart, setCart] = React.useState(JSON.parse(localStorage.getItem("cart")) || []);
    // const len = cart.length

    const [loggedIn , setLoggedIn] = React.useState(false)
    const [cartLen , setCartLen] = React.useState(0);



    React.useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const accessToken = localStorage.getItem("accessToken");

                const config = {
                    withCredentials: true,
                    headers: {}
                };

                // iPhone fallback
                if (accessToken) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }

                let response = await axios.get(`${baseUrl}api/auth/IsLoggedIn`, config);
                // console.log(response)
                setLoggedIn(true);

                response = await axios.get(`${baseUrl}api/cart/get-cart`, config);
                setCartLen(response?.data?.data?.cart?.length || 0);
            } catch (err) {
                console.error("Error while checking login status:", err.response?.data || err.message);
            }
        };

        checkLoginStatus();
    }, []);


    const cartText = React.useMemo(() => {
        return loggedIn ? `Shopping bag (${cartLen})` : "Shopping bag (0)";
    }, [loggedIn, cartLen]);



    return(
        <div className="navbar sticky top-0 z-50 bg-white shadow-sm">

            <div className="nav_top">
                <div className="nav_top_left pl-[5%] flex items-center !gap-[40px]  ">
                    <a href="https://wa.me/+918398862901"><p>Contact Us On</p> <i className="fa-brands fa-whatsapp"></i> </a>
                    <a href="/newsletter"><p>Follow Us On</p> <i className="fa-brands fa-instagram"></i></a>
                    {/* <a href="/find_stores">Find a store</a> */}
                    {/* <a className="text-2xl" href="https://wa.me/+918398862901">
                        <i className="fa-brands fa-whatsapp"></i>
                    </a> */}
                </div>
                <div className="nav_top_middle">
                    {/* <a href="/"><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRq1n8MdAYvQMMDlpTRkvdYosPoxKbmX-4gUw&s" alt="H&M"></img></a>  */}
                    {/* <a className=" flex items-center content-center" href="/"><img className="scale-[3]"  src={jutexx} alt="H&M"></img></a>  */}
                    <Link to="/" className="flex items-center">
                    {/* <h1 className="text-4xl font-display font-semibold text-jute-800">Jutexx</h1> */}
                        <img src="http://res.cloudinary.com/dn6mtzcht/image/upload/v1748098139/fmlseazn7o3dusku0wfc.jpg" alt="logo_img"></img>
                    </Link>
                </div>
                <div className="nav_top_right ">
                    { !loggedIn && 
                        <a href="/login">
                            <i class="fa-light fa-user"></i>
                            <p>Sign in</p>
                        </a>
                    }
                    { loggedIn && 
                        <a href="/profile">
                            <i class="fa-light fa-user"></i>
                            <p>Profile</p>
                        </a>
                    }
                    <a href="/favourites">
                        <i class="fa-light fa-heart"></i>
                        <p>Favourites</p>
                    </a>
                    <a href="/cart">
                        <i class="fa-light fa-bag-shopping"></i>
                         <p>{cartText}</p>
                        
                    </a>
                </div>
            </div>
            <div className="nav_bottom">

                {/* <a href="/store/ladies">Ladies</a>
                <a href="/store/men">Men</a>
                <a href="/store/baby">Baby</a>
                <a href="/store/kids">Kids</a>
                <a href="/store/home">H&M HOME</a>
                <a href="/store/sport">Sport</a>
                <a href="/sale">Sale</a>
                <a href="/sustainability">Sustainability</a> */}
                <a href="/store/products">
                    <p className="text-[16px] font-display font-semibold text-jute-800">View Products</p>
                </a>

            </div>

        </div>
    )
}

export default Navbar